import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import {
  Observable,
  throwError,
  BehaviorSubject,
} from 'rxjs';
import {
  catchError,
  filter,
  switchMap,
  take,
  finalize,
} from 'rxjs/operators';
import { Router } from '@angular/router';
import { API } from '@/constants/api-endpoints';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class httpInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshToken$ = new BehaviorSubject<string | null>(null);

  constructor(private router: Router, private http: HttpClient) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isAuthEndpoint = request.url.includes('/Auth/');

    if (!isAuthEndpoint) {
      request = this.addAuthHeader(request);
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && !isAuthEndpoint) {
          return this.handle401(request, next);
        }
        return throwError(() => error);
      }),
    );
  }

  private addAuthHeader(request: HttpRequest<any>): HttpRequest<any> {
    const token = localStorage.getItem('userToken');
    const isOurApi =
      request.url.includes('i4option.com') ||
      request.url.includes('azurewebsites.net') ||
      request.url.includes('localhost');

   if (!token || !isOurApi) {
    return request;
  }

  // Don't set Content-Type for FormData
  if (request.body instanceof FormData) {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  // JSON requests
  return request.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}
  private handle401(failedRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.isRefreshing) {
      // Wait for the ongoing refresh to complete, then retry
      return this.refreshToken$.pipe(
        filter((token) => token !== null),
        take(1),
        switchMap(() => next.handle(this.addAuthHeader(failedRequest))),
      );
    }

    this.isRefreshing = true;
    this.refreshToken$.next(null);

    // const storedRefreshToken = localStorage.getItem('refreshToken');
    // if (!storedRefreshToken) {
    //   return this.logout();
    // }

    // const expiredAccessToken = localStorage.getItem('userToken') || localStorage.getItem('accessToken') || '';

    return this.http
      .post<any>(`${API.BASE_URL}${API.REFRESH_TOKEN}`,  {}, { withCredentials: true })
      .pipe(
        switchMap((res) => {
          if (!res?.success) {
            return this.logout();
          }
          const newAccessToken: string = res.data.accessToken;
          // const newRefreshToken: string = res.data.refreshToken;
          localStorage.setItem('userToken', newAccessToken);
          localStorage.setItem('accessToken', newAccessToken);
          // localStorage.setItem('refreshToken', newRefreshToken);
          this.refreshToken$.next(newAccessToken);
          return next.handle(this.addAuthHeader(failedRequest));
        }),
        catchError(() => this.logout()),
        finalize(() => { this.isRefreshing = false; }),
      );
  }

  private logout(): Observable<never> {
    localStorage.removeItem('userToken');
    localStorage.removeItem('accessToken');
    // localStorage.removeItem('refreshToken');
    this.router.navigateByUrl('/login');
    return throwError(() => new Error('Session expired. Please log in again.'));
  }
}
